module.exports = __webpack_public_path__ + "static/media/1POLICY42.643c7a5d.jpg";